import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Series extends OBase {
  update () {
    var startValTree = this.getFloatInput('Start');
    var stepValTree = this.getFloatInput('Step');
    var countValTree = this.getFloatInput('Count');

    var output = this.getGenericObjectOutput('Series');

    var dataTrees = [];
    var outDataTrees = [];
    dataTrees.push(startValTree);
    dataTrees.push(stepValTree);
    dataTrees.push(countValTree);

    // console.log(dataTrees)

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    var outTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        var path = new Geometry.GHPath(outDataTrees[0].paths[i]);
        path.add(j);

        var startVal = outDataTrees[0].branches[i][j];
        var stepVal = outDataTrees[1].branches[i][j];
        var countVal = Number(outDataTrees[2].branches[i][j]);

        if(countVal == 0){
          outTree.addEmpty(path);
        }

        for (let t = 0; t < countVal; t++) {
          outTree.add(startVal + t * stepVal, path);
        }
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Series.js